import { datadogRum } from '@datadog/browser-rum';

/** RUM duration vital / timing name for open Requests grid usable. */
export const REQUESTS_OPEN_GRID_VITAL = 'requests_open_grid';

/** Custom action: load-my-work journey success or failure. */
export const REQUESTS_LOAD_MY_WORK_ACTION = 'requests_load_my_work';

export const startRequestsOpenGridVital = () => {
    datadogRum.startDurationVital(REQUESTS_OPEN_GRID_VITAL);
};

export const finishRequestsOpenGridReady = ({ empty }) => {
    datadogRum.stopDurationVital(REQUESTS_OPEN_GRID_VITAL, {
        context: { empty, workflow_flag: true },
    });
    datadogRum.addTiming('requests_open_grid_ready');
    datadogRum.addAction(REQUESTS_LOAD_MY_WORK_ACTION, {
        status: 'success',
        empty,
        workflow_flag: true,
    });
};

export const failRequestsOpenGrid = (reason) => {
    datadogRum.addAction(REQUESTS_LOAD_MY_WORK_ACTION, {
        status: 'error',
        reason: reason ?? 'unknown',
        workflow_flag: true,
    });
};
